module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/id_module/motorrad-logo.png?ed08bee2daff93a4ddbc009bfd153661";